import axios from 'axios'

export class Leitungen{
    static async get(konvKey){
        try {
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/alleLeitungsPositionenByKonvKey',
                { params: { konvKey: konvKey } }
            );

            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    static async getMaxLeitungsID(feuerwehrID){
        try{
          const response = await axios.get(
            'https://feuerwehr-server.org:5000/maxLeitungsID',
            { params: { feuerwehrID: feuerwehrID } }
          );
          return response.data.maxLeitungsID;
        } catch (error) {
          console.error(error);
          // Handle error accordingly
          return null;
        }
    }

    static async addRingleitung(leitungsID, durchlaufmenge, feuerwehrID, position1, position2){
        let leitungNoError = false;
        try{
          const response = await axios.post("https://feuerwehr-server.org:5000/addWasserleitung", {
            leitungsID: leitungsID,
            durchlaufmenge: durchlaufmenge,
            feuerwehrID: feuerwehrID,
          });
          leitungNoError = true;
        } catch(error){
            console.error("Fehler beim Hinzufügen von Wasserleitungsdaten:", error);
            return;
        }

        let position1NoError = await this.addLeitungsPosition(leitungsID, position1.positionsID, position1.position, position1.vorgaenger, position1.nachfolger);
        let position2NoError = await this.addLeitungsPosition(leitungsID, position2.positionsID, position2.position, position2.vorgaenger, position2.nachfolger);
        if(leitungNoError && position1NoError && position2NoError){
            return true;
        } else{
            return false;
        }
    }

    static async addLeitungsPosition(leitungsID, positionsID, position, vorgaenger, nachfolger){
        const positionsData = {
            leitungsID: leitungsID,
            positionsID: positionsID,
            position: position,
            vorgaenger: vorgaenger,
            nachfolger: nachfolger
        };

        try {
          const response = await axios.post('https://feuerwehr-server.org:5000/addLeitungsPosition', positionsData);
          return true;
          console.log(response.data);
        } catch (err) {
          console.error(err);
        }
    }

    static async removeLeitungsposition(leitungsID, positionsID){
        try {
          const response = await axios.delete('https://feuerwehr-server.org:5000/deleteLeitungsPosition/' + leitungsID + '/' + positionsID);
          return true;
          console.log(response.data);
        } catch (err) {
          console.error(err);
          return false;
        }
    }
}
